<script setup lang="ts">
import type { Option } from "@/itemStore";
import { computed, ref } from "vue";

const props = defineProps<{
  options: Option[];
  value: string;
  placeholder: string;
  empty?: string;
}>();

const emit = defineEmits(["select", "open", "close"]);

const openMenu = ref(false);

const getText = computed(() => {
  if (props.value !== "") {
    const value = props.value.split(",");
    for (const option of props.options) {
      if (value.includes(option.value)) {
        return option.text;
      }
    }
  }
  return props.placeholder;
});

const getClass = computed(() => {
  let className = "btn dropdown";
  if (props.value) {
    className += " active";
  }
  return className;
});

const getActiveClass = (value: string) => {
  if (props.value === value) {
    return "active";
  }
  return "";
};

const toggleMenu = () => {
  openMenu.value = !openMenu.value;
  if (openMenu.value) {
    emit("open");
  } else {
    emit("close");
  }
};

const selectValue = (slug: string) => {
  emit("select", slug);
  toggleMenu();
};
</script>

<template>
  <div class="dropdown-container">
    <button :class="getClass" @click="toggleMenu">
      {{ getText }}
    </button>
    <div class="btn-dropdown-menu" v-if="openMenu && props.options.length > 0">
      <button v-if="props.empty && props.value.length > 0" @click="selectValue('')">
        {{ props.empty }}
      </button>
      <button
        v-for="option in props.options"
        :key="option.value"
        :class="`level${option.level} ${getActiveClass(option.value)}`"
        @click="selectValue(option.value)"
      >
        {{ option.text }}
      </button>
    </div>
  </div>
</template>
